import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TenantPerksSettings } from '../../../shared/services/tenant.service';

export interface PerkDetail {
  icon: string;
  title: string;
  desc?: string;
}

@Component({
  selector: 'black-perks-section',
  templateUrl: './perks-section.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class PerksSectionComponent {
  @Input() perks?: TenantPerksSettings;
  @Input() theme: 'modern' | 'warm' | 'bold' = 'modern';

  get title(): string {
    return this.perks?.title || 'What You Get With Every Class Enrollment';
  }

  get defaultPerks(): PerkDetail[] {
    return [
      {
        icon: 'fa-solid fa-video',
        title: 'Full HD Class Recordings',
        desc: 'Missed a session or need revision? Every live class is recorded in crisp 1080p and available on your dashboard 24/7.',
      },
      {
        icon: 'fa-solid fa-file-pdf',
        title: 'Monthly Notes & Theory Tutes',
        desc: 'Comprehensive syllabus study materials, model diagrams, and worked examples available for download or print.',
      },
      {
        icon: 'fa-solid fa-comments',
        title: 'Dedicated Doubt-Clearing Community',
        desc: 'Direct access to WhatsApp / Telegram discussion groups where questions are answered before each class.',
      },
      {
        icon: 'fa-solid fa-pen-ruler',
        title: 'Weekly Paper Drills & Marking',
        desc: 'Structured past paper questions and timed mock tests with in-depth scheme breakdown and grading.',
      },
      {
        icon: 'fa-solid fa-clock-rotate-left',
        title: 'Exam-Focused Revision Batches',
        desc: 'Special fast-track theory summaries and targeted question discussions in the months leading up to exams.',
      },
      {
        icon: 'fa-solid fa-shield-halved',
        title: 'Guaranteed Live Access & Security',
        desc: 'Lag-free interactive Zoom sessions, instant invoice receipts, and secure online card or bank transfer payments.',
      },
    ];
  }

  get perkItems(): PerkDetail[] {
    if (this.perks?.items && this.perks.items.length > 0) {
      return this.perks.items.map((item) => {
        const rawIcon = typeof item === 'string' ? '' : (item.icon || '').trim();
        let icon = 'fa-solid fa-circle-check';
        if (rawIcon) {
          if (
            rawIcon.startsWith('fa-solid ') ||
            rawIcon.startsWith('fa-regular ') ||
            rawIcon.startsWith('fa-brands ') ||
            rawIcon.startsWith('fas ') ||
            rawIcon.startsWith('far ') ||
            rawIcon.startsWith('fab ')
          ) {
            icon = rawIcon;
          } else if (rawIcon.startsWith('fa-')) {
            icon = `fa-solid ${rawIcon}`;
          } else {
            icon = `fa-solid fa-${rawIcon}`;
          }
        }
        return {
          icon,
          title: typeof item === 'string' ? item : item.title,
          desc: typeof item === 'string' ? '' : (item.description || ''),
        };
      });
    }
    return this.defaultPerks;
  }
}
